import { __extends } from "tslib";
import { EventBase } from './EventBase';
var TimerEvent = /** @class */ (function (_super) {
    __extends(TimerEvent, _super);
    function TimerEvent(type) {
        return _super.call(this, type) || this;
    }
    /**
     *
     */
    TimerEvent.TIMER = 'timer';
    /**
     *
     */
    TimerEvent.TIMER_COMPLETE = 'timerComplete';
    return TimerEvent;
}(EventBase));
export { TimerEvent };
